<template>
  <div class="mainCont">
    <div class="test-survey-builder">
      <h2 class="text-center">Build your Survey</h2>
      <hr />

      <QuestionsView :questions="questionsList" :readOnly="true" />
      <div v-if="addQuestion">
        <SurveyBuilder :options="sampleQuestion" />
      </div>
      <div class="pt-10">
        <button
          type="button"
          class="add_another_btn br-25"
          v-on:click="addNewQuestion()"
        >
          Add question
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  SurveyBuilder,
  SurveyBuilderJson,
  QuestionsView
} from "vue-survey-builder";

export default {
  name: "Quiz.container",
  data() {
    return {
      questionsList: [],
      addQuestion: false
    };
  },
  mounted() {
    this.$root.$on("add-update-question", q => {
      this.updateQuestionsList(q);
    });
  },
  components: { SurveyBuilder, QuestionsView },
  methods: {
    updateQuestionsList(question) {
      const questionIndex = this.questionsList.findIndex(
        x => x.id === question.id
      );
      if (questionIndex >= 0) {
        this.questionsList.splice(questionIndex, 1, question);
      } else {
        this.questionsList.push(JSON.parse(JSON.stringify(question)));
      }
      this.addQuestion = false;
      this.$root.$emit("selected-question", null);
      ///// window.console.log(question, this.addQuestion, this.questionsList);
    },
    addNewQuestion() {
      this.sampleQuestion = JSON.parse(JSON.stringify(SurveyBuilderJson));
      this.addQuestion = true;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.add_another_btn {
  font-size: 14px;
  background-color: transparent;
  border-color: #4c8ce4;
  color: #4c8ce4;
  padding: 8px;
  cursor: pointer;
}
.text-center {
  text-align: center;
}

.pt-10 {
  margin-left: 5px !important;
}

div.row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
</style>

<!--<template>-->
<!--    &lt;!&ndash;container&ndash;&gt;-->
<!--    <section class="container">-->

<!--        &lt;!&ndash;questionBox&ndash;&gt;-->
<!--        <div class="questionBox" id="app">-->

<!--            &lt;!&ndash; transition &ndash;&gt;-->
<!--            <transition :duration="{ enter: 500, leave: 300 }" enter-active-class="animated zoomIn" leave-active-class="animated zoomOut" mode="out-in">-->

<!--                &lt;!&ndash;qusetionContainer&ndash;&gt;-->
<!--                <div class="questionContainer" v-if="questionIndex<quiz.questions.length" v-bind:key="questionIndex">-->

<!--                    <header>-->
<!--                        <h1 class="title is-6">Test Yourself</h1>-->
<!--                        &lt;!&ndash;progress&ndash;&gt;-->
<!--                        <div class="progressContainer">-->
<!--                            <progress class="progress is-info is-small" :value="(questionIndex/quiz.questions.length)*100" max="100">{{(questionIndex/quiz.questions.length)*100}}%</progress>-->
<!--                            <p>{{(questionIndex/quiz.questions.length)*100}}% complete</p>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;/progress&ndash;&gt;-->
<!--                    </header>-->

<!--                    &lt;!&ndash; questionTitle &ndash;&gt;-->
<!--                    <h2 class="titleContainer title">{{ quiz.questions[questionIndex].text }}</h2>-->

<!--                    &lt;!&ndash; quizOptions &ndash;&gt;-->
<!--                    <div class="optionContainer">-->
<!--                        <div class="option" v-for="(response, index) in quiz.questions[questionIndex].responses" @click="selectOption(index)" :class="{ 'is-selected': userResponses[questionIndex] == index}" :key="index">-->
<!--                            {{ index | charIndex }}. {{ response.text }}-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    &lt;!&ndash;quizFooter: navigation and progress&ndash;&gt;-->
<!--                    <footer class="questionFooter">-->

<!--                        &lt;!&ndash;pagination&ndash;&gt;-->
<!--                        <nav class="pagination" role="navigation" aria-label="pagination">-->

<!--                            &lt;!&ndash; back button &ndash;&gt;-->
<!--                            <a class="button" v-on:click="prev();" :disabled="questionIndex < 1">-->
<!--                                Back-->
<!--                            </a>-->

<!--                            &lt;!&ndash; next button &ndash;&gt;-->
<!--                            <a class="button" :class="(userResponses[questionIndex]==null)?'':'is-active'" v-on:click="next();" :disabled="questionIndex>=quiz.questions.length">-->
<!--                                {{ (userResponses[questionIndex]==null)?'Skip':'Next' }}-->
<!--                            </a>-->

<!--                        </nav>-->
<!--                        &lt;!&ndash;/pagination&ndash;&gt;-->

<!--                    </footer>-->
<!--                    &lt;!&ndash;/quizFooter&ndash;&gt;-->

<!--                </div>-->
<!--                &lt;!&ndash;/questionContainer&ndash;&gt;-->

<!--                &lt;!&ndash;quizCompletedResult&ndash;&gt;-->
<!--                <div v-if="questionIndex >= quiz.questions.length" v-bind:key="questionIndex" class="quizCompleted has-text-centered">-->

<!--                    &lt;!&ndash; quizCompletedIcon: Achievement Icon &ndash;&gt;-->
<!--                    <span class="icon">-->
<!--					<i class="fa" :class="score()>3?'fa-check-circle-o is-active':'fa-times-circle'"></i>-->
<!--				</span>-->

<!--                    &lt;!&ndash;resultTitleBlock&ndash;&gt;-->
<!--                    <h2 class="title">-->
<!--                        You did {{ (score()>4?'a good':'a poor') }} job!-->
<!--                    </h2>-->
<!--                    <p class="subtitle">-->
<!--                        Total score: {{ score() }} / {{ quiz.questions.length }}-->
<!--                    </p>-->
<!--                    <br>-->
<!--                    <a class="button" @click="restart()">restart <i class="fa fa-refresh"></i></a>-->
<!--                    &lt;!&ndash;/resultTitleBlock&ndash;&gt;-->

<!--                </div>-->
<!--                &lt;!&ndash;/quizCompetedResult&ndash;&gt;-->

<!--            </transition>-->

<!--        </div>-->
<!--        &lt;!&ndash;/questionBox&ndash;&gt;-->

<!--    </section>-->
<!--    &lt;!&ndash;/container&ndash;&gt;-->
<!--</template>-->

<!--<script>-->
<!--    import www.txt from 'lodash'-->
<!--    import {SurveyBuilder,SurveyBuilderJson,QuestionsView} from 'vue-survey-builder';-->
<!--    import Vue from 'vue';-->
<!--    const quiz = {-->
<!--            user: "Dave",-->
<!--            questions: [-->
<!--                {-->
<!--                    text: "What is the full form of HTTP?",-->
<!--                    responses: [-->
<!--                        { text: "Hyper text transfer package" },-->
<!--                        { text: "Hyper text transfer protocol", correct: true },-->
<!--                        { text: "Hyphenation text test program" },-->
<!--                        { text: "None of the above" }-->
<!--                    ]-->
<!--                },-->
<!--                {-->
<!--                    text: "HTML document start and end with which tag pairs?",-->
<!--                    responses: [-->
<!--                        { text: "HTML", correct: true },-->
<!--                        { text: "WEB" },-->
<!--                        { text: "HEAD" },-->
<!--                        { text: "BODY" }-->
<!--                    ]-->
<!--                },-->
<!--                {-->
<!--                    text: "Which tag is used to create body text in HTML?",-->
<!--                    responses: [-->
<!--                        { text: "HEAD" },-->
<!--                        { text: "BODY", correct: true },-->
<!--                        { text: "TITLE" },-->
<!--                        { text: "TEXT" }-->
<!--                    ]-->
<!--                },-->
<!--                {-->
<!--                    text: "Outlook Express is _________",-->
<!--                    responses: [-->
<!--                        { text: "E-Mail Client", correct: true },-->
<!--                        { text: "Browser" },-->
<!--                        {-->
<!--                            text: "Search Engine"-->
<!--                        },-->
<!--                        { text: "None of the above" }-->
<!--                    ]-->
<!--                },-->
<!--                {-->
<!--                    text: "What is a search engine?",-->
<!--                    responses: [-->
<!--                        { text: "A hardware component " },-->
<!--                        {-->
<!--                            text: "A machinery engine that search data"-->
<!--                        },-->
<!--                        { text: "A web site that searches anything", correct: true },-->
<!--                        { text: "A program that searches engines" }-->
<!--                    ]-->
<!--                },-->
<!--                {-->
<!--                    text:-->
<!--                        "What does the .com domain represents?",-->
<!--                    responses: [-->
<!--                        { text: "Network" },-->
<!--                        { text: "Education" },-->
<!--                        { text: "Commercial", correct: true },-->
<!--                        { text: "None of the above" }-->
<!--                    ]-->
<!--                },-->
<!--                {-->
<!--                    text: "In Satellite based communication, VSAT stands for? ",-->
<!--                    responses: [-->
<!--                        { text: " Very Small Aperture Terminal", correct: true },-->
<!--                        { text: "Varying Size Aperture Terminal " },-->
<!--                        {-->
<!--                            text: "Very Small Analog Terminal"-->
<!--                        },-->
<!--                        { text: "None of the above" }-->
<!--                    ]-->
<!--                },-->
<!--                {-->
<!--                    text: "What is the full form of TCP/IP? ",-->
<!--                    responses: [-->
<!--                        { text: "Telephone call protocol / international protocol" },-->
<!--                        { text: "Transmission control protocol / internet protocol", correct: true },-->
<!--                        { text: "Transport control protocol / internet protocol " },-->
<!--                        { text: "None of the above" }-->
<!--                    ]-->
<!--                },-->
<!--                {-->
<!--                    text:-->
<!--                        "What is the full form of HTML?",-->
<!--                    responses: [-->
<!--                        {-->
<!--                            text: "Hyper text marking language"-->
<!--                        },-->
<!--                        { text: "Hyphenation text markup language " },-->
<!--                        { text: "Hyper text markup language", correct: true },-->
<!--                        { text: "Hyphenation test marking language" }-->
<!--                    ]-->
<!--                },-->
<!--                {-->
<!--                    text: "\"Yahoo\", \"Infoseek\" and \"Lycos\" are _________?",-->
<!--                    responses: [-->
<!--                        { text: "Browsers " },-->
<!--                        { text: "Search Engines", correct: true },-->
<!--                        { text: "News Group" },-->
<!--                        { text: "None of the above" }-->
<!--                    ]-->
<!--                }-->
<!--            ]-->
<!--        }-->
<!--        const userResponseSkelaton = Array(quiz.questions.length).fill(null);-->

<!--    export default {-->
<!--        name: "Quiz.container",-->
<!--        data() {-->
<!--            return {-->
<!--                questionsList: [],-->
<!--                addQuestion: false,-->
<!--                quiz: quiz,-->
<!--                questionIndex: 0,-->
<!--                userResponses: userResponseSkelaton,-->
<!--                isActive: false-->
<!--            };-->
<!--        },-->
<!--        filters: {-->
<!--            charIndex: function(i) {-->
<!--                return String.fromCharCode(97 + i);-->
<!--            }-->
<!--        },-->
<!--        watch:{-->
<!--            userResponses:function(){-->
<!--                // console.log(this.userResponses)-->
<!--            }-->

<!--        },-->
<!--        methods: {-->
<!--            restart(){-->
<!--                this.questionIndex=0;-->

<!--                this.userResponses=Array(this.quiz.questions.length).fill(null);-->
<!--            },-->
<!--            selectOption(index){-->
<!--                let vm = this;-->
<!--                Vue.set(this.userResponses, this.questionIndex, index);-->

<!--            },-->
<!--            next: function() {-->
<!--                if (this.questionIndex < this.quiz.questions.length)-->
<!--                    this.questionIndex++;-->
<!--            },-->

<!--            prev: function() {-->
<!--                if (this.quiz.questions.length > 0) this.questionIndex&#45;&#45;;-->
<!--            },-->
<!--            // Return "true" count in userResponses-->
<!--            score: function() {-->
<!--                var score = 0;-->
<!--                for (let i = 0; i < this.userResponses.length; i++) {-->
<!--                    if (-->
<!--                        typeof this.quiz.questions[i].responses[-->
<!--                            this.userResponses[i]-->
<!--                            ] !== "undefined" &&-->
<!--                        this.quiz.questions[i].responses[this.userResponses[i]].correct-->
<!--                    ) {-->
<!--                        score = score + 1;-->
<!--                    }-->
<!--                }-->
<!--                return score;-->

<!--                //return this.userResponses.filter(function(val) { return val }).length;-->
<!--            }-->
<!--        }-->
<!--    };-->
<!--</script>-->

<!--&lt;!&ndash; Add "scoped" attribute to limit CSS to this component only &ndash;&gt;-->
<!--<style scoped>-->
<!--    @import url("https://fonts.googleapis.com/css?family=Montserrat:400,400i,700");-->
<!--    @import url("https://fonts.googleapis.com/css?family=Open+Sans:400,400i,700");-->
<!--    body {-->
<!--        font-family: "Open Sans", sans-serif;-->
<!--        font-size: 14px;-->
<!--        height: 100vh;-->
<!--        background: #cfd8dc;-->
<!--        /* mocking native UI */-->
<!--        cursor: default !important;-->
<!--        /* remove text selection cursor */-->
<!--        -webkit-user-select: none;-->
<!--        -moz-user-select: none;-->
<!--        -ms-user-select: none;-->
<!--        user-select: none;-->
<!--        /* remove text selection */-->
<!--        user-drag: none;-->
<!--        /* disbale element dragging */-->
<!--        display: -webkit-box;-->
<!--        display: flex;-->
<!--        -webkit-box-align: center;-->
<!--        align-items: center;-->
<!--        -webkit-box-pack: center;-->
<!--        justify-content: center;-->
<!--    }-->

<!--    .button {-->
<!--        -webkit-transition: 0.3s;-->
<!--        transition: 0.3s;-->
<!--    }-->

<!--    .title,-->
<!--    .subtitle {-->
<!--        font-family: Montserrat, sans-serif;-->
<!--        font-weight: normal;-->
<!--    }-->

<!--    .animated {-->
<!--        -webkit-transition-duration: 0.15s;-->
<!--        transition-duration: 0.15s;-->
<!--    }-->

<!--    .container {-->
<!--        margin: 0 0.5rem;-->
<!--        display: flex;-->
<!--        justify-content: center;-->
<!--    }-->

<!--    .questionBox {-->
<!--        max-width: 30rem;-->
<!--        width: 30rem;-->
<!--        min-height: 30rem;-->
<!--        background: #fafafa;-->
<!--        position: relative;-->
<!--        display: -webkit-box;-->
<!--        display: flex;-->
<!--        border-radius: 0.5rem;-->
<!--        overflow: hidden;-->
<!--        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);-->
<!--    }-->
<!--    .questionBox header {-->
<!--        background: rgba(0, 0, 0, 0.025);-->
<!--        padding: 1.5rem;-->
<!--        text-align: center;-->
<!--        border-bottom: 1px solid rgba(0, 0, 0, 0.1);-->
<!--    }-->
<!--    .questionBox header h1 {-->
<!--        font-weight: bold;-->
<!--        margin-bottom: 1rem !important;-->
<!--    }-->
<!--    .questionBox header .progressContainer {-->
<!--        width: 60%;-->
<!--        margin: 0 auto;-->
<!--    }-->
<!--    .questionBox header .progressContainer > progress {-->
<!--        margin: 0;-->
<!--        border-radius: 5rem;-->
<!--        overflow: hidden;-->
<!--        border: none;-->
<!--        color: #3d5afe;-->
<!--    }-->
<!--    .questionBox header .progressContainer > progress::-moz-progress-bar {-->
<!--        background: #3d5afe;-->
<!--    }-->
<!--    .questionBox header .progressContainer > progress::-webkit-progress-value {-->
<!--        background: #3d5afe;-->
<!--    }-->
<!--    .questionBox header .progressContainer > p {-->
<!--        margin: 0;-->
<!--        margin-top: 0.5rem;-->
<!--    }-->
<!--    .questionBox .titleContainer {-->
<!--        text-align: center;-->
<!--        margin: 0 auto;-->
<!--        padding: 1.5rem;-->
<!--    }-->
<!--    .questionBox .quizForm {-->
<!--        display: block;-->
<!--        white-space: normal;-->
<!--        height: 100%;-->
<!--        width: 100%;-->
<!--    }-->
<!--    .questionBox .quizForm .quizFormContainer {-->
<!--        height: 100%;-->
<!--        margin: 15px 18px;-->
<!--    }-->
<!--    .questionBox .quizForm .quizFormContainer .field-label {-->
<!--        text-align: left;-->
<!--        margin-bottom: 0.5rem;-->
<!--    }-->
<!--    .questionBox .quizCompleted {-->
<!--        width: 100%;-->
<!--        padding: 1rem;-->
<!--        text-align: center;-->
<!--    }-->
<!--    .questionBox .quizCompleted > .icon {-->
<!--        color: #ff5252;-->
<!--        font-size: 5rem;-->
<!--    }-->
<!--    .questionBox .quizCompleted > .icon .is-active {-->
<!--        color: #00e676;-->
<!--    }-->
<!--    .questionBox .questionContainer {-->
<!--        white-space: normal;-->
<!--        height: 100%;-->
<!--        width: 100%;-->
<!--    }-->
<!--    .questionBox .questionContainer .optionContainer {-->
<!--        margin-top: 12px;-->
<!--        -webkit-box-flex: 1;-->
<!--        flex-grow: 1;-->
<!--    }-->
<!--    .questionBox .questionContainer .optionContainer .option {-->
<!--        border-radius: 290486px;-->
<!--        padding: 9px 18px;-->
<!--        margin: 0 18px;-->
<!--        margin-bottom: 12px;-->
<!--        -webkit-transition: 0.3s;-->
<!--        transition: 0.3s;-->
<!--        cursor: pointer;-->
<!--        background-color: rgba(0, 0, 0, 0.05);-->
<!--        color: rgba(0, 0, 0, 0.85);-->
<!--        border: transparent 1px solid;-->
<!--    }-->
<!--    .questionBox .questionContainer .optionContainer .option.is-selected {-->
<!--        border-color: rgba(0, 0, 0, 0.25);-->
<!--        background-color: white;-->
<!--    }-->
<!--    .questionBox .questionContainer .optionContainer .option:hover {-->
<!--        background-color: rgba(0, 0, 0, 0.1);-->
<!--    }-->
<!--    .questionBox .questionContainer .optionContainer .option:active {-->
<!--        -webkit-transform: scaleX(0.9);-->
<!--        transform: scaleX(0.9);-->
<!--    }-->
<!--    .questionBox .questionContainer .questionFooter {-->
<!--        background: rgba(0, 0, 0, 0.025);-->
<!--        border-top: 1px solid rgba(0, 0, 0, 0.1);-->
<!--        width: 100%;-->
<!--        align-self: flex-end;-->
<!--    }-->
<!--    .questionBox .questionContainer .questionFooter .pagination {-->
<!--        margin: 15px 25px;-->
<!--    }-->

<!--    .pagination {-->
<!--        display: -webkit-box;-->
<!--        display: flex;-->
<!--        -webkit-box-pack: justify;-->
<!--        justify-content: space-between;-->
<!--    }-->

<!--    .button {-->
<!--        padding: 0.5rem 1rem;-->
<!--        border: 1px solid rgba(0, 0, 0, 0.25);-->
<!--        border-radius: 5rem;-->
<!--        margin: 0 0.25rem;-->
<!--        -webkit-transition: 0.3s;-->
<!--        transition: 0.3s;-->
<!--    }-->
<!--    .button:hover {-->
<!--        cursor: pointer;-->
<!--        background: #eceff1;-->
<!--        border-color: rgba(0, 0, 0, 0.25);-->
<!--    }-->
<!--    .button.is-active {-->
<!--        background: #3d5afe;-->
<!--        color: white;-->
<!--        border-color: transparent;-->
<!--    }-->
<!--    .button.is-active:hover {-->
<!--        background: #0a2ffe;-->
<!--    }-->

<!--    @media screen and (min-width: 769px) {-->
<!--        .questionBox {-->
<!--            -webkit-box-align: center;-->
<!--            align-items: center;-->
<!--            -webkit-box-pack: center;-->
<!--            justify-content: center;-->
<!--        }-->
<!--        .questionBox .questionContainer {-->
<!--            display: -webkit-box;-->
<!--            display: flex;-->
<!--            -webkit-box-orient: vertical;-->
<!--            -webkit-box-direction: normal;-->
<!--            flex-direction: column;-->
<!--        }-->
<!--    }-->
<!--    @media screen and (max-width: 768px) {-->
<!--        .sidebar {-->
<!--            height: auto !important;-->
<!--            border-radius: 6px 6px 0px 0px;-->
<!--        }-->
<!--    }-->
<!--    @media (min-width: 1200px){-->
<!--        .container {-->
<!--            width: 95%;-->
<!--        }-->
<!--        div#app {-->
<!--            margin-top: 50px;-->
<!--        }-->
<!--        }-->

<!--</style>-->
